import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { combineLatest, filter, map } from 'rxjs';
import { BaseComponent } from '../../components/base.component';
import { OnboardingContainerComponent } from '../../components/onboarding-container/onboarding-container.component';

@Component({
  imports: [OnboardingContainerComponent, TranslocoPipe],
  templateUrl: './redirect.component.html',
})
export class RedirectComponent extends BaseComponent {
  readonly #destroyRef = inject(DestroyRef);

  protected override submit(): Promise<void> | void {
    // nothing to do
  }

  protected override populateFromData(): void {
    combineLatest([
      this.facade.onboardingData$,
      this.facade.onboardingDataLoading$,
      this.facade.isPhoneNumberVerified$,
      this.facade.isPhoneNumberVerifiedLoading$,
      this.facade.doInitialDepositLater$,
    ])
      .pipe(
        filter(
          ([onboardingData, onboardingDataLoading, , isPhoneNumberVerifiedLoading]) =>
            !onboardingDataLoading && (!onboardingData?.cMobileNr || !isPhoneNumberVerifiedLoading),
        ),
        map(([onboardingData, , isPhoneNumberVerified, doInitialDepositLater]) =>
          this.facade.getNextRouteBasedOnData(onboardingData, isPhoneNumberVerified, doInitialDepositLater),
        ),
        map((route) => this.facade.getStepByRoute(route)),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe((step) => this.facade.goToStep(step));
  }

  protected override listenToSuccessfulSubmit(): void {
    // nothing to do
  }
}
